import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=09723bee&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09723bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09723bee')) {
      api.createRecord('09723bee', component.options)
    } else {
      api.reload('09723bee', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=09723bee&scoped=true&", function () {
      api.rerender('09723bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28dA5JMfFc1wJ/JS/comp/Accordion.vue"
export default component.exports